<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">姓名</div>
          <div class="field">
            <el-input v-model.trim="query.expertname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">电话</div>
          <div class="field">
            <el-input v-model.trim="query.expertmobile" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" @cellClick="cellClick"
            @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'expertIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        btn:{},
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'expertname', fieldtype: 'C', title: '姓名',calculExpr:'', addNewRowFlg: false},
          { field: 'expertsex', fieldtype: 'C', title: '性别',calculExpr:'',addNewRowFlg: false},
          { field: 'expertidtypename', fieldtype: 'C',title: '证件类型',calculExpr:'',addNewRowFlg: false},
          { field: 'expertidcode', fieldtype: 'C',title: '证件号码',calculExpr:'',addNewRowFlg: false},
          { field: 'expertmobile', fieldtype: 'C',title: '联系电话',calculExpr:'',addNewRowFlg: false},
          { field: 'expertstatusname', fieldtype: 'C',title: '状态',calculExpr:'',addNewRowFlg: false}
        ],
        expertform: false,
        expert: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addExpert())
      this.$on('CHG', () => this.chgExpert())
      this.$on('DEL', () => this.delExpert())
      this.$on('AUTH', () => this.auth())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      init(){
        this.menuid = this.$route.query.menuid
        this.list = []
        this.expert = {}
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.expert = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addExpert () {
        let form = {
          expertid: 0
        }
        this.$router.push({name: 'expertForm', params: {form: form, type: 1}})
      },
      async chgExpert () {
        if (!this.expert.expertid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'expertForm', params: {form: this.expert, type: 2}})
      },
      async delExpert () {
        if (!this.expert.expertid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/expert/delExpert',
            method: "post",
            data: this.expert
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async auth () {
        this.$router.push({name: 'expertmenuForm', params: {form: this.expert}})
      },
      async cellClick (row) {
        this.expert = row.row
      },
      async viewProject(row) {
        this.expert = row.row
        
        this.$router.push({name: 'expertForm', params: {form: this.expert,innerbtn: this.btn.inner, type: 3}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/expert/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
